export function createFactorViewPayload(payload) {
  return {
    ...(payload && payload),
    view: "performance",
  }
}
